export const ROUTES = {
  main: '/',
  home: '/home',
  dashboard: '/',
  emailOutreach: '/outreach/email',
  mailingHistory: '/outreach/history',
  emailBlacklist: '/outreach/blacklist',
  whatsappOutreach: '/outreach/whatsapp',
  whatsappHistory: '/outreach/whatsapp-history',
  whatsappInbox: '/outreach/whatsapp-inbox',
  messengerInbox: '/outreach/messenger-inbox',
  instagramInbox: '/outreach/instagram-inbox',
  socialComments: '/outreach/social-comments',
  tiktokComments: '/outreach/tiktok-comments',
  adminUsers: '/admin/users',
  leadsManage: '/leads/manage',
  phoneBlacklist: '/outreach/phone-blacklist',

  // Auth
  login: '/login',
  register: '/register',
  verifyEmail: '/verify-email',
  forgotPassword: '/forgot-password',
  changePassword: '/change-password',
  pendingApproval: '/pending-approval',

  // Main
  profile: '/home/profile',
  notFound: '*',
};

export const API_ROUTES = {
  // Auth
  login: '/auth/login/',
  logout: '/auth/logout/',
  refresh: '/auth/token/refresh/',
  signup: '/auth/registration/',
  resendEmail: '/resend-email-confirmation/',
  confirmEmail: '/auth/registration/account-confirm-email/',
  changePassword: '/auth/password/change/',
  resetPassword: '/auth/password/reset/',
  resetPasswordConfirm: '/auth/password/reset/confirm/',

  // Other
  profile: '/api/auth/profile/',
  adminUsers: '/api/v1/admin/users/',
  adminCheckEmail: '/api/v1/admin/users/check-email/',

  // Leads
  places: '/api/v1/places/',
  placesStats: '/api/v1/places/stats/',
  persons: '/api/v1/persons/',
  personsSelectAll: '/api/v1/persons/select-all/',

  // Outreach
  emailTemplates: '/api/v1/email/templates/',
  emailSend: '/api/v1/email/send/',
  emailGenerate: '/api/v1/email/generate/',
  emailProgress: '/api/v1/email/progress/',
  emailGenerateTest: '/api/v1/email/generate-test/',
  emailTest: '/api/v1/email/test/',
  emailHistory: '/api/v1/email/history/',
  emailStats: '/api/v1/email/stats/',
  emailEngagement: '/api/v1/email/engagement/',
  emailNonResponders: '/api/v1/email/non-responders/',
  emailWebhook: '/api/v1/email/webhook/sendgrid/',
  emailBlacklist: '/api/v1/email/blacklist/',
  phoneBlacklist: '/api/v1/phone-blacklist/',

  // WhatsApp
  whatsappTemplates: '/api/v1/whatsapp/templates/',
  whatsappTemplatesSync: '/api/v1/whatsapp/templates/sync/',
  whatsappSend: '/api/v1/whatsapp/send/',
  whatsappHistory: '/api/v1/whatsapp/history/',
  whatsappStats: '/api/v1/whatsapp/stats/',
  whatsappGenerate: '/api/v1/whatsapp/generate/',
  whatsappGenerateTest: '/api/v1/whatsapp/generate-test/',
  whatsappTest: '/api/v1/whatsapp/test/',
  whatsappWebhook: '/api/v1/whatsapp/webhook/',

  // WhatsApp Inbox
  whatsappConversations: '/api/v1/whatsapp/conversations/',
  whatsappAgentConfig: '/api/v1/whatsapp/agent-config/',
  whatsappInboxStats: '/api/v1/whatsapp/inbox/stats/',
  whatsappMessageMedia: '/api/v1/whatsapp/messages/',

  // Messenger Inbox
  messengerConversations: '/api/v1/messenger/conversations/',
  messengerAgentConfig: '/api/v1/messenger/agent-config/',
  messengerInboxStats: '/api/v1/messenger/inbox/stats/',
  messengerComments: '/api/v1/messenger/comments/',
  messengerCommentRules: '/api/v1/messenger/comment-rules/',

  // Instagram Inbox
  instagramConversations: '/api/v1/instagram/conversations/',
  instagramAgentConfig: '/api/v1/instagram/agent-config/',
  instagramInboxStats: '/api/v1/instagram/inbox/stats/',
  instagramComments: '/api/v1/instagram/comments/',

  // Shared comment rules (used by FB, IG, TikTok)
  commentAutoReplyRules: '/api/v1/comment-rules/',

  // TikTok
  tiktokVideos: '/api/v1/tiktok/videos/',
  tiktokVideoSync: '/api/v1/tiktok/videos/sync/',
  tiktokAgentConfig: '/api/v1/tiktok/agent-config/',
  tiktokStats: '/api/v1/tiktok/stats/',
};

// Only these paths dont require to send a token
// See /lib/axios.ts
export const NO_AUTH_REQUIRED_API_ROUTES = [
  API_ROUTES.login,
  API_ROUTES.refresh,
  API_ROUTES.signup,
  API_ROUTES.resendEmail,
  API_ROUTES.confirmEmail,
  API_ROUTES.resetPassword,
  API_ROUTES.resetPasswordConfirm,
];
